<template>
  <div id="app" class="app">
    <MainWrapper />
  </div>
</template>

<script>
import MainWrapper from "./components/v-main-wrapper.vue";

export default {
  name: "App",
  components: {
    MainWrapper
  }
};
</script>

<style scoped>
.app {
  min-height: 100%;
  height: 100%;
  background-color: rgb(245, 245, 245);
}
</style>

